export const promotions = {
    ended: "已結束",
    endDay: "結束",
    closed: "已結團",
    groupBuy: "本次團購",
    countdownClose: "結團倒數",
    countdownCloseSingle: "倒數",
    countdownCloseSinglePromotion: "活動倒數",
    comingSoonSingle: "再等",
    conditionAmount: "滿額",
    conditionQty: "滿件",
    discountTypeAmount: "折扣金額",
    discountTypePercentage: "%折扣",
    less: "小於",
    newArrival: "最新上架",
    expireDate: "到期時間",
    bestSelling: "熱銷",
    empty: "沒有更多促銷了",
    notYetStarted: "尚未開始",
    selectSpec: "立即購買",
    freeGift: "送贈品",
    bundle: "任選",
    fill: "滿",
    fillUnit: "件",
    gift: "送",
    discounts: "折",
    code: "折扣碼",
    saveCode: "儲存折扣碼",
    saveCodeSuccess: "儲存折扣碼完成",
    now: "現在",
    past: "過去",
    memberOnly: "限定會員使用",
    lowAmount: "最低消費",
    expiryDate: "有效期限",
    timesLeft: "剩餘",
    discount: "折扣",
    maxAmount: "最高",
    emptyCodes: "沒有更多折扣碼了",
    subtotal: "全站可用",
    categories: "指定分類",
    products: "指定商品",
    types: {
        campaign: "滿減滿贈活動",
        kol: "開團加盟活動",
        wholesale: "批發分銷活動",
        distribute: "分銷活動",
        distribute_limited: "分銷限量活動",
        cycle: "循環購",
        code: "折扣碼",
        bundle: "商店任選活動",
        kol_bundle: "開團任選活動",
        distribute_bundle: "分銷任選活動",
    },
    promotions: "指定活動",
    promotionCodeValidAt: "於 {0} 失效",
    promotionMaxUseLimit: "發行量: {0} 張",
    promotionTotalRemaining: "剩餘: {0} "
}
